import React from 'react';
import { storeData } from '../../data/storeData';
import StoreTemplate from '../../components/StoreTemplate';
import fortysecondImg from '../../assets/images/42ndOutside.jpg';

function FortySecond() {
    return <StoreTemplate storeData={storeData.fortysecond} storeImage={fortysecondImg} />;
}

export default FortySecond; 